export default "__VITE_ASSET__BSoRP5sZ__"